export function sanitizeClasscode(input: string): string {
  return input.toUpperCase().replace(/\s/g, "").slice(0, 6)
}
